import React from "react";
import { Alert } from "@mui/material";
import Loading from "components/Loading";
import { normalizePartnerTier } from "constants/partnerTiers";
import { useAuth } from "hooks/useAuth";

/**
 * Fusion Founder org admins only (stored tier `founding`). Global admins use OrganizationsPage.
 * Shaped by prompt 35; MKT-05. Invariant: alias/redirect only; gate unchanged.
 * Fusion / affiliate / none / non-admin roles are denied.
 */
export function FoundingPartnerAccountingGate({ children }) {
  const { organization, organizationLoading, userData } = useAuth();

  if (organizationLoading) {
    return <Loading page />;
  }

  const isOrgAdmin = userData?.role === "admin";
  const isFounding =
    normalizePartnerTier(organization?.partnerTier) === "founding";

  if (!isOrgAdmin || !isFounding) {
    return (
      <Alert severity="warning">
        Partner accounting is available to Fusion Founder organization admins
        only.
      </Alert>
    );
  }

  return children;
}

export default FoundingPartnerAccountingGate;
